import { useGetMyProfileQuery } from '@massilia/queries'
import { Button } from '@massilia/ui'
import { Loader2, LogOut } from 'lucide-react'

import { useLogout } from '@/hooks/use-logout'

import { EmailsSection } from './emails-section'
import { PassengersSection } from './passengers-section'
import { PasswordSection } from './password-section'
import { PersonalDataSection } from './personal-data-section'
import { PhoneNumbersSection } from './phone-numbers-section'

export function PersonalInformationsPage() {
  const { data: profile, isLoading } = useGetMyProfileQuery()
  const handleLogout = useLogout()

  // Les passagers enregistrés ne concernent que les particuliers (B2C).
  const isB2b = profile?.client?.clientType === 'COMPANY'

  return (
    <div className="flex flex-1 flex-col">
      {/* Le héro et la navigation sont rendus par le layout de l'espace client. */}
      <main className="mx-auto flex w-full max-w-3xl flex-1 flex-col gap-6 bg-white px-6 py-8 md:py-10">
        {isLoading || !profile ? (
          <div className="flex items-center justify-center py-14">
            <Loader2 className="size-8 animate-spin text-brand-600" />
          </div>
        ) : (
          <div className="flex flex-col gap-6">
            <h2 className="text-xl font-semibold text-gray-light-900">Données personnelles</h2>

            {/* Personal data */}
            <PersonalDataSection profile={profile} />

            {/* Phone numbers */}
            <PhoneNumbersSection profile={profile} />

            {/* Emails */}
            <EmailsSection profile={profile} />

            {/* Password */}
            <PasswordSection />

            {/* Passengers (B2C uniquement) */}
            {!isB2b && <PassengersSection />}
          </div>
        )}

        {/* Logout button */}
        <Button
          className="w-fit gap-2 border-red-200 text-red-600 hover:bg-red-50 hover:text-red-700"
          onClick={() => void handleLogout()}
          variant="outline"
        >
          <LogOut className="size-4" />
          Se déconnecter
        </Button>
      </main>
    </div>
  )
}
